module.exports = __webpack_public_path__ + "static/img/kefuerweima.04915fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newhome/kefuerweima.jpg
// module id = phFY
// module chunks = 311